<template>
  <div id="container-joystick">
    <div id="val-joy-u">
      <span class="sdf-text-17-400-white">{{ forwardValueDisplay }}</span>
    </div>
    <div id="con-joy-u" :style="{ backgroundColor: forwardColor }">
      <feather-icon
        icon="ArrowUpIcon"
        svgClasses="h-4 w-4"
      />
    </div>
    <div id="val-joy-l">
      <span class="sdf-text-17-400-white">{{ leftValueDisplay }}</span>
    </div>
    <div id="con-joy-l" :style="{ backgroundColor: leftColor }">
      <feather-icon icon="ArrowLeftIcon" svgClasses="h-4 w-4" />
    </div>
    <div id="val-joy-r">
      <span class="sdf-text-17-400-white">{{ rightValueDisplay }}</span>
    </div>
    <div id="con-joy-r" :style="{ backgroundColor: rightColor }">
      <feather-icon icon="ArrowRightIcon" svgClasses="h-4 w-4" />
    </div>
    <div id="con-joy-d" :style="{ backgroundColor: backwardColor }">
      <feather-icon icon="ArrowDownIcon" svgClasses="h-4 w-4" />
    </div>
    <div id="val-joy-d">
      <span class="sdf-text-17-400-white">{{ backwardValueDisplay }}</span>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins/addon/secure-dataflow";

export default {
  mixins: [ColorMixin],
  components: {},
  props: {
    forwardValue: {
      type: Number,
      default: 100
    },
    rightValue: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      zeroPercent: `0.0%`,
      nullDisplay: "---",
    };
  },
  computed: {
    forwardValueDisplay() {
      if (this.forwardValue === null) return this.nullDisplay;
      if (Math.sign(this.forwardValue) === 1) {
        return `${Math.abs(this.forwardValue)}%`;
      } else {
        return this.zeroPercent;
      }
    },
    backwardValueDisplay() {
      if (this.forwardValue === null) return this.nullDisplay;
      if (Math.sign(this.forwardValue) === -1) {
        return `${Math.abs(this.forwardValue)}%`;
      } else {
        return this.zeroPercent;
      }
    },
    rightValueDisplay() {
      if (this.forwardValue === null) return this.nullDisplay;
      if (Math.sign(this.rightValue) === 1) {
        return `${Math.abs(this.rightValue)}%`;
      } else {
        return this.zeroPercent;
      }
    },
    leftValueDisplay() {
      if (this.forwardValue === null) return this.nullDisplay;
      if (Math.sign(this.rightValue) === -1) {
        return `${Math.abs(this.rightValue)}%`;
      } else {
        return this.zeroPercent;
      }
    },
    forwardColor() {
      if (Math.sign(this.forwardValue) === 1) {
        return this.sdfColor.LightGreen;
      } else {
        return this.sdfColor.DarkNavy;
      }
    },
    backwardColor() {
      if (Math.sign(this.forwardValue) === -1) {
        return this.sdfColor.LightGreen;
      } else {
        return this.sdfColor.DarkNavy;
      }
    },
    rightColor() {
      if (Math.sign(this.rightValue) === 1) {
        return this.sdfColor.LightGreen;
      } else {
        return this.sdfColor.DarkNavy;
      }
    },
    leftColor() {
      if (Math.sign(this.rightValue) === -1) {
        return this.sdfColor.LightGreen;
      } else {
        return this.sdfColor.DarkNavy;
      }
    }
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/monitoringVesselManeuvering/joystick.scss";
</style>
